import { render, staticRenderFns } from "./menu2_video_clip.vue?vue&type=template&id=6087b158&scoped=true"
import script from "./menu2_video_clip.vue?vue&type=script&lang=js"
export * from "./menu2_video_clip.vue?vue&type=script&lang=js"
import style0 from "./menu2_video_clip.vue?vue&type=style&index=0&id=6087b158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6087b158",
  null
  
)

export default component.exports